import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch } from 'react-redux';
import { PrismicDocumentTypes } from '../prismic';
import { fetchPrismicPage } from '../redux/pages';
import { FishingReportsPage } from './fishing_reports_page';

const FishingReportsPageContainer = () => {
  const dispatch = useDispatch();

  useFrontload('FishingReportsPageContainer', async () => {
    await dispatch(fetchPrismicPage(PrismicDocumentTypes.FISHING_REPORTS_PAGE));

    return true;
  });

  return <FishingReportsPage />;
};

export default FishingReportsPageContainer;
